// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__JvpCD","row":"Node_row__2zAii","label":"Node_label__PonE8","footer":"Node_footer__pvlRq"};